var exports = {
  "k": "x936d19a0--27d6d6--container",
  "Q": "x936d19a0--27d6d6--content",
};

module.exports = exports;
